export function formatPhoneNumber(str) {
    if (str && typeof str === "string") {
        return str.slice(1, str.length);
    } else {
        return "";
    }
}

export function toLowerCaseTransform(str) {
    return str && typeof str === "string" ? str.toLowerCase() : "";
}

export function generateReference(prefix = "", suffix = "") {
    const length = 12;
    const timestamp = new Date().getTime();

    function _getRandInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function generate() {
        const ts = timestamp.toString();
        const parts = ts.split("").reverse();
        let ref = "";

        for (let i = 0; i < length; ++i) {
            const index = _getRandInt(0, parts.length - 1);
            ref += parts[index];
        }

        return ref;
    }

    return prefix + generate() + suffix;
}

/**
 * @param {string} filename
 * @param {string} content - Raw content.
 * @param {"text"| "image"} filetype
 */
export function downloadFromString(filename, content, filetype) {
    const element = document.createElement("a");

    if (filetype === "image") {
        element.setAttribute("href", "data:image/png;base64," + encodeURIComponent(content));
    } else {
        element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(content));
    }

    element.setAttribute("download", filename);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

export function splitFullName(name = "") {
    const names = String(name).split(" ");
    if (names.length === 1) {
        return [names[0], ""];
    }
    const firstName = names.slice(0, names.length - 1).join(" ");
    const lastName = names[names.length - 1];
    return [firstName, lastName];
}

export function simpleUniqueID() {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return "_" + Math.random().toString(36).substr(2, 9);
};

export function camelCaseToSpaced(str) {
    // Replace capital letters with a space followed by the lowercase version
    return str.replace(/([A-Z])/g, " $1").toLowerCase();
}